<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame" id="_idContainer014">
<p class="Author-tp"><span class="CharOverride-1">Anna Carina Mohipp</span></p>
<p class="Title-tp"><span class="CharOverride-2"><img alt="" class="_idGenObjectAttribute-1" role="presentation" src="image/1.jpg"/></span><span class="CharOverride-2"> <br/></span><span class="CharOverride-2"><img alt="" class="_idGenObjectAttribute-2" role="presentation" src="image/2.jpg"/></span></p>
<div class="_idGenObjectLayout-1">
<div class="Imprint" id="_idContainer002">
<img alt="" class="_idGenObjectAttribute-3" role="presentation" src="image/Logo-for-titlepages-new-CMYK.jpg"/>
</div>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781398499331_EPUB.vue?8640c2dc